<div class="card_default">
  <div class="card_body">
    <div class="card_header">
      <h4>{{ "general.attachments" | translate }}</h4>
    </div>
    <div class="card_content">
        <ul class="list_feedbacks_comments mb-4" *ngIf="recordsData.data && recordsData.data.length;else dataEmpty">
          <li *ngFor="let record of recordsData.data; let i = index">
            <div class="feedback_container" *ngIf="!record.loading">
              <div class="feedback_body">
                <div class="feedback_thumbnail">
                  <img *ngIf="record.createdByLogo" [src]="record.createdByLogo" (error)='record.createdByLogo = ""'>
                  <span *ngIf="!record.createdByLogo">
                    {{ record.createdByName| shortName }}
                  </span>
                </div>
                <div class="feedback_content">
                  <div class="date_time">
                    {{record.createdDate| date:'d MMM yyyy - h:mm a'}}
                  </div>
                  <div class="auther_name">
                    {{ record.createdByName }}
                  </div>
                  <div class="feedback_attachments">
                    <app-file-manager [files]="[record]" [docsEditable]="false" [canDelete]="record.canDelete"
                      (deletedFilesList)="deletedFiles($event); record.loading = true" [managerIndex]='"attachments"+i'></app-file-manager>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>
      <div class="text-center mb-5" *ngIf="pageNumber <= pageCount - 1">
        <button mat-raised-button color="primary" (click)="getNextPage()" [class.loading]='loading'
          [disabled]='loading'>
          {{ "general.showMore" | translate}}
        </button>
      </div>
      <ng-container *ngIf="recordsData.canUpload">
        <app-file-manager class="w-100" [isRequired]="true" [isSubmitted]="isSubmited" [allowedExt]="allowedExt"
          [maxSize]="5" [label]="'fileManager.dragAndDropFilesHere'|translate" [files]="files"
          (selectedFiles)="files = $event"></app-file-manager>
        <div class="d-flex justify-content-end mt-3">
          <button type="button" (click)="saveRecord()" mat-raised-button color="primary"
            [disabled]="loading || !files.length" [class.loading]="loading">
            {{ "forms.Submit" | translate}}
          </button>
        </div>
      </ng-container>

    </div>
  </div>
</div>

<ng-template #dataEmpty>
  <empty-state [img]="'assets/images/illu_empty_state.png'" [hideTitle]="true"
    [desc]='"general.noFilesAdded"|translate'></empty-state>
</ng-template>